import { useRepo } from "pinia-orm";
import Building from "./Building";
import Component from "./Component";
import Zone from "./Zone";
import OtherItem from "./OtherItem";
import AosOutdoorSpace from "./AosOutdoorSpace";
import Spreading from "./Spreading";
import AosSite from "./AosSite";
import BasiasBasolSisNearbySiteOther from "./BasiasBasolSisNearbySiteOther";
import _ from "lodash";

export const SITE = "SITE";
export const BUILDING = "BUILDING";
export const ZONE = "ZONE";
export const COMPONENT = "COMPONENT";
export const OUTDOOR_SPACE = "OUTDOOR_SPACE";
export const SPREADING = "SPREADING";
export const OTHER_ITEM = "OTHER_ITEM";
export const BASIAS_BASOL_SIS_NEARBY_SITE_OTHER = "BASIAS_BASOL_SIS_NEARBY_SITE_OTHER";

export const AosMapping = {
  [BUILDING]: Building,
  [ZONE]: Zone,
  [SITE]: AosSite,
  [OTHER_ITEM]: OtherItem,
  [OUTDOOR_SPACE]: AosOutdoorSpace,
  [SPREADING]: Spreading,
  [COMPONENT]: Component,
  [BASIAS_BASOL_SIS_NEARBY_SITE_OTHER]: BasiasBasolSisNearbySiteOther,
};

export const insertMarkers = (data) => {
  if (!Array.isArray(data)) data = [data];
  return data.map((datum) => insertMarker(datum));
};

export const insertMarker = (data) => {
  const Model = AosMapping[data.aosType];
  const ModelRepo = useRepo(Model);
  let long = 0;
  let lat = 0;
  if (data.geolocation) {
    [long, lat] = data.geolocation.split(",");
  }
  if (data.manualGeolocation) {
    const [manualLong, manualLat] = data.manualGeolocation.split(",");
    data = {
      ...data,
      manualLat,
      manualLong,
    };
  }
  return ModelRepo.save(
    _.omit(
      {
        ...data,
        projectsUuids: data.projects,
        marker: {
          uuid: data.uuid,
          parent_uuid: data.site,
          lat,
          long,
        },
      },
      "projects",
    ),
  );
};

export const insertAosItems = (data) => {
  if (!Array.isArray(data)) data = [data];
  return data.map((item) => {
    const Model = AosMapping[item.aosType];
    const ModelRepo = useRepo(Model);
    return ModelRepo.save({ ...item, projectsUuids: item.projects });
  });
};

export const extractCoordinatesFromFeature = (feature) => {
  const coordinates = feature.geometry.coordinates[0];
  if (coordinates.length) {
    return feature.geometry.coordinates[0].map((element) => element.join(","));
  }
};

export const formatCoordinates = (coordinates) => {
  if (coordinates.length) {
    return coordinates.map((element) => element.split(",").map(Number));
  }
};

export const flushCartographyData = () => {
  Object.values(AosMapping).forEach((Model) => {
    const ModelRepo = useRepo(Model);
    ModelRepo.flush();
  });
};
